import { render, staticRenderFns } from "./MspLibreriaAllenamenti.vue?vue&type=template&id=61651b46"
import script from "./MspLibreriaAllenamenti.vue?vue&type=script&lang=js"
export * from "./MspLibreriaAllenamenti.vue?vue&type=script&lang=js"
import style0 from "./MspLibreriaAllenamenti.vue?vue&type=style&index=0&id=61651b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports